import React, { Component } from "react";
import { push } from "connected-react-router";
import { setBreadcrumb, setLoader, setTitle } from "store/actions";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Table } from "components";
import { API, Endpoints } from "utils/api";
import { notification } from "antd";
import Strings from "utils/strings";
import { DateTime } from "luxon";

class WorkshopPurchases extends Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			purchases: []
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(setTitle(""));
		dispatch(setBreadcrumb(null));

		this.getData();
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.get({
				url: Endpoints.uriWorkshopPurchases()
			});

			if (response.ok) {
				this.setState({ purchases: response.data?.results?.purchase || [] });
			}
		} catch (err) {
			console.log("API Error", err);
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async removePurchase(id: string) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.delete({
				url: Endpoints.uriWorkshopPurchases(id)
			});

			if (response.ok) {
				this.setState({ purchases: response.data?.results?.purchase || [] });

				notification.success({
					message: Strings.workshop.purchase,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { purchases = [] } = this.state;
		const { dispatch } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.workshop.purchases}</title>
					<meta name="description" content="Description of Workshop Purchases" />
				</Helmet>
				<Table
					title={{
						icon: "shopping-cart",
						title: Strings.workshop.purchases
					}}
					data={purchases}
					columns={[
						{
							Header: Strings.workshop.date,
							id: "date",
							accessor: (row: any) =>
								row.date && DateTime.fromISO(row.date).toFormat("dd/MM/yyyy")
						},
						{
							Header: Strings.workshop.supplier,
							id: "supplier",
							accessor: (row: any) => (row.supplier || "-")
						},
						{
							Header: Strings.workshop.invoiceNumber,
							id: "invoiceNumber",
							accessor: (row: any) => row.invoiceNumber || "-"
						},
						{
							Header: Strings.workshop.items,
							id: "items",
							accessor: (row: any) => (row.totalItems || 0) + " " + Strings.workshop.items
						},
						{
							Header: Strings.workshop.total,
							id: "total",
							align: "right",
							accessor: (row: any) => (row.total && `${row.total.toFixed(2)} €`) || "-"
						},
						{
							Header: Strings.fields.notes,
							id: "notes",
							accessor: (row: any) => row.notes || "-"
						}
					]}
					filterable
					isSinglePage
					fullPage
					paginated={false}
					add={{
						onClick: () => dispatch(push("/workshop/purchases/new"))
					}}
					actions={{
						edit: (original: any) => ({
							onClick: () => dispatch(push(`/workshop/purchases/${original._id}`))
						}),
						remove: (original: any) => ({
							onClick: () => this.removePurchase(original._id)
						})
					}}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(WorkshopPurchases);

